import { FC } from "react";
import { useRecoilState } from "recoil";
import myInfoState from "../../atoms/myinfo";
import waitingRoomState from "../../atoms/waiting-room";
import "./Room.scoped.scss";

interface RoomProps {
  thumbnailUrl: string;
  name: string;
  participants: number;
  maxParticipants: number;
  ownerLevel: number;
  ownerName: string;
  roomId: string;
  isSecret: boolean;
}

const Room: FC<RoomProps> = ({
  thumbnailUrl,
  name,
  participants,
  maxParticipants,
  ownerLevel,
  ownerName,
  roomId,
  isSecret,
}) => {
  const [myInfo] = useRecoilState(myInfoState);
  const [waitingRoom, setWaitingRoom] = useRecoilState(waitingRoomState);

  const enterRoom = () => {
    if (myInfo.userDetail == null || myInfo.userDetail.id === '') {
      window.alert('로그인 후 이용해주세요.');
      return;
    }
    if (!isSecret) {
      window.location.href = `/chatting-app/room/${roomId}`;
    } else {
      setWaitingRoom({
        ...waitingRoom,
        isOpenedEnteringSecretRoom: true,
        tryingRoomId: roomId,
      })
    }
  }

  return (
    <div className="room">
      <div>
        <img
          className="room__thumbnail"
          src={thumbnailUrl}
          alt=""
        />
      </div>
      <div className="room__title-and-participants">
        <div>
          <div className="room__title">
            {name}
            {
              isSecret
                ? (
                  <span className="room__secret-simbol">[비밀방]</span>
                )
                : null
            }
          </div>
          <div className="room__participants">
            <b>{participants}</b> / {maxParticipants}
          </div>
        </div>
        {
        /*
        <div className="room__time">2시간 전</div>
        */
        }
      </div>
      <div className="room__profile-and-enter-button">
        <div className="room__profile">
          <img src={`/img/level/level_img/${ownerLevel}.png`} alt="" />
					<span>{ownerName}</span>
        </div>
        <div className="room__enter-button">
          <button
            onClick={enterRoom}
          >
            채팅방 입장하기
          </button>
        </div>
      </div>
    </div>
  );
}

export default Room;
